/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { IntegrationDto } from '../models/integration-dto';
import { integrationsControllerUpdate } from '../fn/integrations/integrations-controller-update';
import { IntegrationsControllerUpdate$Params } from '../fn/integrations/integrations-controller-update';

@Injectable({ providedIn: 'root' })
export class PlatformIntegrationsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `integrationsControllerUpdate()` */
  static readonly IntegrationsControllerUpdatePath = '/api/v1/integrations/{storeId}';

  /**
   * Partially update the integration for a store.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `integrationsControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  integrationsControllerUpdate$Response(
    params: IntegrationsControllerUpdate$Params,
    context?: HttpContext
  ): Observable<StrictHttpResponse<IntegrationDto>> {
    const obs = integrationsControllerUpdate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Partially update the integration for a store.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `integrationsControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  integrationsControllerUpdate(
    params: IntegrationsControllerUpdate$Params,
    context?: HttpContext
  ): Observable<IntegrationDto> {
    const resp = this.integrationsControllerUpdate$Response(params, context);
    return resp.pipe(map((r: StrictHttpResponse<IntegrationDto>): IntegrationDto => r.body));
  }
}
